import { useState, useEffect } from "react";
import { InputNumber, Space, Typography } from "antd";

import {
  formatNumberWithThousands,
  isNumberInputInRange,
  normalizeDecimalInput,
  NUMBER_INPUT_RANGE_MESSAGE,
  parseCentsToDisplay,
  parseDisplayToCents,
  parseNumberInput,
} from "@/utils/fieldValueConverter";

const InputMoney = ({
  value,
  onChange,
  onKeyDown,
  onFocus,
  onValidate,
  ...props
}) => {
  const [displayValue, setDisplayValue] = useState(parseCentsToDisplay(value));
  const isValid = isNumberInputInRange(displayValue);

  useEffect(() => {
    setDisplayValue(parseCentsToDisplay(value));
  }, [value]);

  useEffect(() => {
    onValidate?.(isValid);
    // onValidate часто передается как inline-функция, поэтому следим только за значением.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValid]);

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = (e.clipboardData || window.clipboardData).getData("text");

    const normalizedValue = normalizeDecimalInput(paste);
    const numericValue = parseNumberInput(normalizedValue);
    if (numericValue === null || Number.isNaN(numericValue)) {
      setDisplayValue(null);
      onChange?.(null);
      return;
    }

    setDisplayValue(normalizedValue);
    onChange?.(parseDisplayToCents(normalizedValue));
  };

  const handleBlur = () => {
    onChange?.(parseDisplayToCents(displayValue));
  };

  const handleFocus = (e) => {
    onFocus?.(e);
    const inputElement = e?.target;
    requestAnimationFrame(() => {
      inputElement?.select?.();
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !isValid) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    onKeyDown?.(e, parseDisplayToCents(displayValue));
  };

  return (
    <div style={{ width: "100%" }}>
      <Space.Compact>
        <InputNumber
          value={displayValue}
          step="0.01"
          precision={2}
          stringMode
          status={isValid ? undefined : "error"}
          formatter={formatNumberWithThousands}
          parser={normalizeDecimalInput}
          onBlur={handleBlur}
          onFocus={handleFocus}
          onPaste={handlePaste}
          onChange={(val) => {
            setDisplayValue(val);
            onChange?.(parseDisplayToCents(val));
          }}
          onKeyDown={handleKeyDown}
          {...props}
        />
        <span className="input-after">руб.</span>
      </Space.Compact>
      {!isValid && (
        <Typography.Text type="danger" style={{ display: "block", fontSize: 12 }}>
          {NUMBER_INPUT_RANGE_MESSAGE}
        </Typography.Text>
      )}
    </div>
  );
};

export default InputMoney;
